export default function doesCountryRequireCookies(countryCode: string) {
  return countryCode === 'PE'
}
